module.exports = __webpack_public_path__ + "static/standard-dcb9a983086e7383038bb0f86c5471da.jpg";